import React from 'react'
import PropTypes from 'prop-types'
import { get, isNull } from 'lodash-es'
import { track } from '../../../../utils/analytics'
import {
  AjaxButtonComponent,
  AnimateComponent,
  Button as ButtonComponent,
  CenteredModalContentComponent,
  ClipboardButtonComponent,
} from '../../../../components'
import { CRUDContainerComponent } from '../index'

import './ModeContentSwitchComponent.scss'

const getButtonLoadingProps = (text) => ({
  okText: text,
  loadingText: text,
  successText: text,
})
const getButton = (props, text) => (
  <ButtonComponent outlined {...props}>
    {text}
  </ButtonComponent>
)
const renderChancelButton = (onClick) =>
  getButton({ color: 'grey', onClick }, 'Cancel')
const ajaxButtonProps = getButtonLoadingProps('Delete Speaker')

const ModeContentSwitchComponent = (props) => {
  const {
    crudMode,
    okButtonState,
    onSubmit,
    sizeCenteredModalIcon,
    addedSpeaker,
    openCrudModal,
    isCrudModalVisible,
    closeCrudModal,
    addCancelButton,
    isSendInviteButtonVisible,
    crudSpeakerId,
    sendInvite,
    isCrudSpeakerInviteSent,
    sendInviteSpeakerId,
  } = props

  const addedSpeakerId = get(addedSpeaker, 'live_speaker_id')
  const speakerName = get(addedSpeaker, 'name', '')

  let content

  switch (crudMode) {
    case 'edit':
    case 'new': {
      content = (
        <CRUDContainerComponent
          mode={crudMode}
          okButtonState={okButtonState}
          isVisible={isCrudModalVisible}
          onCancel={closeCrudModal}
          onSubmit={onSubmit}
          openCrudModal={openCrudModal}
          addCancelButton={addCancelButton}
          isSendInviteButtonVisible={isSendInviteButtonVisible}
          sendInvite={sendInvite}
          crudSpeakerId={crudSpeakerId}
          isCrudSpeakerInviteSent={isCrudSpeakerInviteSent}
        />
      )
      break
    }
    case 'delete': {
      content = (
        <AnimateComponent
          duration={200}
          transitionName="animation-fade"
          transitionOn={['appear']}
        >
          <div className="centered-modal-wrapper delete-speaker-content-wrapper">
            <CenteredModalContentComponent
              icon="cancel"
              size={sizeCenteredModalIcon}
            >
              <h3>Are you sure you want to delete this speaker?</h3>
              <p>This will remove this person from this event permanently</p>
              {renderChancelButton(closeCrudModal)}
              <AjaxButtonComponent
                color="red"
                state={okButtonState}
                {...ajaxButtonProps}
                onClick={() => onSubmit('delete', crudSpeakerId)}
              >
                Delete Speaker
              </AjaxButtonComponent>
            </CenteredModalContentComponent>
          </div>
        </AnimateComponent>
      )
      break
    }
    case 'speaker-added': {
      content = (
        <AnimateComponent
          duration={200}
          transitionName="animation-fade"
          transitionOn={['appear']}
        >
          <div className="centered-modal-wrapper speaker-added-wrapper">
            <CenteredModalContentComponent
              icon="check"
              size={sizeCenteredModalIcon}
            >
              <h3>{`${speakerName} is added as a speaker`}</h3>
              <p>
                Do you want to copy the speaker link to share, or just send an
                invitation mail?
              </p>
              <div className="buttons-wrapper">
                <ClipboardButtonComponent text={addedSpeaker.room_link}>
                  <ButtonComponent outlined color="grey">
                    Copy Speaker Link
                  </ButtonComponent>
                </ClipboardButtonComponent>
                <AjaxButtonComponent
                  state={isNull(sendInviteSpeakerId) ? 'idle' : 'loading'}
                  onClick={() => {
                    sendInvite(addedSpeakerId)
                    track('Clicked Send Invite', {
                      product: 'WebinarManagement',
                      context: 'after-create-speaker',
                    })
                  }}
                  {...getButtonLoadingProps('Send Invitation Mail')}
                >
                  Send Invitation Mail
                </AjaxButtonComponent>
              </div>
            </CenteredModalContentComponent>
          </div>
        </AnimateComponent>
      )
      break
    }
    case 'invitation-sent': {
      content = (
        <AnimateComponent
          duration={200}
          transitionName="animation-fade"
          transitionOn={['appear']}
        >
          <div className="centered-modal-wrapper new-invite-success-wrapper">
            <CenteredModalContentComponent
              icon="check"
              size={sizeCenteredModalIcon}
            >
              <h3>Invitation Sent Successfully</h3>
              <p>
                You can add additional details about your speaker&nbsp;
                <span
                  className="link"
                  onClick={() => openCrudModal('edit', addedSpeakerId)}
                >
                  here
                </span>
              </p>
            </CenteredModalContentComponent>
          </div>
        </AnimateComponent>
      )
      break
    }
    default:
      content = null
  }

  return <div className="mode-content-switch-component">{content}</div>
}

ModeContentSwitchComponent.propTypes = {
  crudMode: PropTypes.oneOf([
    'new',
    'speaker-added',
    'invitation-sent',
    'edit',
    'delete',
  ]),
  onSubmit: PropTypes.func,
  openCrudModal: PropTypes.func,
  closeCrudModal: PropTypes.func,
  addedSpeaker: PropTypes.object,
  isCrudModalVisible: PropTypes.bool,
  save: PropTypes.func,
  isSendInviteButtonVisible: PropTypes.bool,
  addCancelButton: PropTypes.bool,
  sendInvite: PropTypes.func,
  sendInviteSpeakerId: PropTypes.string,
  crudSpeakerId: PropTypes.string,
  isCrudSpeakerInviteSent: PropTypes.bool,
  sizeCenteredModalIcon: PropTypes.oneOf(['small', 'normal']),
  okButtonState: PropTypes.oneOf(['idle', 'loading', 'success', 'failure']),
}

export default ModeContentSwitchComponent
